import React, { useState } from "react";
import "./Card.css";


import chettinad from "../../assets/chettinad.jpg";
import bukara from "../../assets/bukara.jpg";
import karavalli from "../../assets/karavalli.jpg";
import dumpukht from "../../assets/dumpukht.jpg";
import accent from "../../assets/accent.jpg";
import saravana from "../../assets/saravana.jpg";
import nation from "../../assets/nation.jpg";
import mainland from "../../assets/mainland.jpg";
import calcutta from "../../assets/calcutta.jpg";
import canteen from "../../assets/canteen.jpg";
import gaylord from "../../assets/gaylord.jpg";
import paragon from "../../assets/paragon.jpg";
import tiffin from "../../assets/tiffin.jpg";
import thali from "../../assets/thali.jpg";
import sheep from "../../assets/sheep.jpg";
import dhaba from "../../assets/dhaba.jpg";
import peter from "../../assets/peter.jpg";
import paradise from "../../assets/paradise.jpg";
import classic from "../../assets/classic.jpg";
import darbar from "../../assets/darbar.jpg";
import yellow from "../../assets/yellow.jpg";
import bowl from "../../assets/bowl.jpg";
import shree from "../../assets/shree.jpg";
import sauces from "../../assets/sauces.jpg";
import served from "../../assets/served.jpg";
import delicious from "../../assets/delicious.jpg";
import beyti from "../../assets/beyti.jpg";
import pizzaaa from "../../assets/pizzaaa.jpg";
import chopstick from "../../assets/chopstick.jpg";
import mud from "../../assets/mud.jpg";
import charcoal from "../../assets/charcoal.jpg";
import canton from "../../assets/canton.jpg";

const restaurants = [
  {
    pic: chettinad,
    name: "Anjappar Chettinad Restaurant",
    address: "Chennai, Tamil Nadu, India",
    rating: 4.5,
  },
  {
    pic: bukara,
    name: "Bukhara",
    address: "ITC Maurya, New Delhi, India",
    rating: 4.7,
  },
  {
    pic: karavalli,
    name: "Karavalli",
    address: "The Gateway Hotel, Bengaluru, Karnataka, India",
    rating: 4.6,
  },
  {
    pic: dumpukht,
    name: "Dum Pukht",
    address: "ITC Maurya, New Delhi, India",
    rating: 4.8,
  },
  {
    pic: accent,
    name: "Indian Accent",
    address: "The Lodhi, New Delhi, India",
    rating: 4.9,
  },
  {
    pic: saravana,
    name: "Saravana Bhavan",
    address: "Chennai, Tamil Nadu, India",
    rating: 4.3,
  },
  {
    pic: nation,
    name: "Barbeque Nation",
    address: "Mumbai, Maharashtra, India",
    rating: 4.4,
  },
  {
    pic: mainland,
    name: "Mainland China",
    address: "Kolkata, West Bengal, India",
    rating: 4.2,
  },
  {
    pic: calcutta,
    name: "Oh! Calcutta",
    address: "Kolkata, West Bengal, India",
    rating: 4.5,
  },
  {
    pic: canteen,
    name: "The Bombay Canteen",
    address: "Mumbai, Maharashtra, India",
    rating: 4.6,
  },

  {
    pic: gaylord,
    name: "Gaylord Restaurant",
    address: "Churchgate, Mumbai, Maharashtra, India",
    rating: 4.4,
  },
  {
    pic: paragon,
    name: "Paragon Restaurant",
    address: "Kozhikode, Kerala, India",
    rating: 4.5,
  },
  {
    pic: tiffin,
    name: "MTR (Mavalli Tiffin Room)",
    address: "Lalbagh Road, Bengaluru, Karnataka, India",
    rating: 4.6,
  },
  {
    pic: thali,
    name: "Rajdhani Thali Restaurant",
    address: "Phoenix Marketcity, Mumbai, Maharashtra, India",
    rating: 4.2,
  },
  {
    pic: sheep,
    name: "The Black Sheep Bistro",
    address: "Panaji, Goa, India",
    rating: 4.4,
  },
  {
    pic: dhaba,
    name: "Kesar Da Dhaba",
    address: "Amritsar, Punjab, India",
    rating: 4.5,
  },
  {
    pic: peter,
    name: "Peter Cat",
    address: "Park Street, Kolkata, West Bengal, India",
    rating: 4.6,
  },
  {
    pic: paradise,
    name: "Paradise Biryani",
    address: "Secunderabad, Telangana, India",
    rating: 4.3,
  },
  {
    pic: classic,
    name: "Ritz Classic",
    address: "Panaji, Goa, India",
    rating: 4.4,
  },
  {
    pic: darbar,
    name: "Delhi Darbar",
    address: "Colaba, Mumbai, Maharashtra, India",
    rating: 4.2,
  },

    {  pic:yellow,name: "Behind Yellow Doors Diner", address: "Sigra, Varanasi, Uttar Pradesh, India", rating: 4.9 },
    {  pic:shree, name: "Shree Shivay Thali Dining", address: "Varanasi, Uttar Pradesh, India", rating: 4.7 },
    {  pic:sauces,name: "The Palate (Ramada Plaza)", address: "Ramada Plaza by Wyndham JHV, Varanasi, Uttar Pradesh, India", rating: 4.8 },
    {  pic:served,name: "Tadka (Ramada Plaza)", address: "Ramada Plaza by Wyndham JHV, Varanasi, Uttar Pradesh, India", rating: 4.8 },
    {  pic:delicious, name: "1916 Café & Restaurant", address: "Varanasi, Uttar Pradesh, India", rating: 4.9 },
    {  pic:beyti,name: "Aadha-Aadha Café", address: "Varanasi, Uttar Pradesh, India", rating: 4.8 },
    {   pic:bowl,name: "Bowl of Compassion", address: "Varanasi, Uttar Pradesh, India", rating: 4.8 },
    {   pic:pizzaaa,name: "Pizzeria Vaatika Café", address: "Assi Ghat, Varanasi, Uttar Pradesh, India", rating: 4.0 },
    {  pic:chopstick,name: "Holy Chopsticks", address: "Nadesar Main Road, Varanasi, Uttar Pradesh, India", rating: 4.4 },
    {  pic:mud,name: "The Mud House", address: "Dashashwamedh Road, Varanasi, Uttar Pradesh, India", rating: 4.1 },
    {  pic:charcoal,name: "Charcoal Fine Dining", address: "Mahmoorganj, Varanasi, Uttar Pradesh, India", rating: 3.9 },
    {  pic:canton,name: "Canton Royale Restaurant", address: "Varanasi, Uttar Pradesh, India", rating: 4.2 },
 
  
];


const Card = () => {
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(restaurants.length / itemsPerPage);
  const indexLast = currentPage * itemsPerPage;
  const indexFirst = indexLast - itemsPerPage;
  const currentRestaurants = restaurants.slice(indexFirst, indexLast);

  const changePage = (num) => setCurrentPage(num);
  const prevPage = () => setCurrentPage(p => Math.max(p - 1, 1));
  const nextPage = () => setCurrentPage(p => Math.min(p + 1, totalPages));

  return (
    <>
      <div className="restaurant-grid">
        {currentRestaurants.map((r, idx) => (
          <div className="restaurant-card" key={idx}>
            <div className="imagess">
              <img
                src={r.pic}
                alt={r.name}
                className="restaurant-image"
              />
            </div>
            <div className="data">
              <h3 className="restaurant-name">{r.name}</h3>
              <p className="restaurant-address">{r.address}</p>
              <p className="restaurant-rating">⭐ {r.rating}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>Prev</button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            onClick={() => changePage(i + 1)}
            className={i + 1 === currentPage ? "active" : ""}
          >
            {i + 1}
          </button>
        ))}
        <button onClick={nextPage} disabled={currentPage === totalPages}>Next</button>
      </div>
    </>
  );
};

export default Card;

